import React from 'react'

import LocationSearch from '../LocationSearch'

import styles from './Header.module.css'


export default () => {
  return (
    <div className={styles.Header}>
      <div className={styles.controls}>
        <LocationSearch />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js